import React from 'react'
import StatCounter from 'statcounter'

const VisitCounter = () => {
    return (<div>
        Number of visitors to this site
        <StatCounter sc_project={4373615} sc_security="f4a3bec0"
                     sc_image_url="https://c.statcounter.com/4373615/0/f4a3bec0/1/" />
    </div>);
}

export default VisitCounter;
